var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiverseEquitableInclusiveTeamsStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9653_7890)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.4,
    width: 46.4,
    height: 12,
    fill: "#F09896"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 12,
    width: 46.4,
    height: 12,
    fill: "#E0967B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4,
    y: 12,
    width: 33.6,
    height: 12,
    fill: "#AA4D49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9653_7890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiverseEquitableInclusiveTeamsStack);
export default __webpack_public_path__ + "static/media/diverse-equitable-inclusive-teams-stack.1407bf8c7d1c994322be5bd1d37f4acb.svg";
export { ForwardRef as ReactComponent };